import type { CoopState, DuelInvite } from '../../shared/protocol.ts';
import { DUEL_INVITE_TTL_MS } from '../../shared/game-rules.ts';
import { $ } from '../common/dom.ts';

/** Petit menu contextuel affiché en cliquant sur un autre dresseur. */
export class PlayerMenu {
  private readonly root = $('#player-menu');
  private target: { id: number; username: string } | null = null;

  constructor(onChallenge: (playerId: number) => void, onInspect: (player: { id: number; username: string }) => void, onCard: (player: { id: number; username: string }) => void,
    onCoop: (playerId: number) => void) {
    $('[data-menu="duel"]', this.root).addEventListener('click', () => {
      if (this.target) onChallenge(this.target.id);
      this.close();
    });
    $('[data-menu="coop"]', this.root).addEventListener('click', () => {
      if (this.target) onCoop(this.target.id);
      this.close();
    });
    $('[data-menu="inspect"]', this.root).addEventListener('click', () => {
      if (this.target) onInspect(this.target);
      this.close();
    });
    $('[data-menu="card"]', this.root).addEventListener('click', () => {
      if (this.target) onCard(this.target);
      this.close();
    });
  }

  get isOpen(): boolean {
    return !this.root.hidden;
  }

  open(player: { id: number; username: string }, screenX: number, screenY: number): void {
    this.target = { id: player.id, username: player.username };
    $('.player-menu-name', this.root).textContent = player.username;
    this.root.style.left = `${Math.min(screenX, innerWidth - 200)}px`;
    this.root.style.top = `${Math.min(screenY, innerHeight - 100)}px`;
    this.root.hidden = false;
  }

  close(): void {
    this.root.hidden = true;
    this.target = null;
  }
}

/** Invitation reçue (duel, ou coop avec `#coop-invite`) ; expire en même temps que côté serveur. */
export class InviteDialog {
  private readonly root: HTMLElement;
  private invite: DuelInvite | null = null;
  private timer: ReturnType<typeof setTimeout> | undefined;

  constructor(onRespond: (fromId: number, accept: boolean) => void, selector = '#duel-invite') {
    this.root = $(selector);
    this.root.addEventListener('click', (event) => {
      const choice = (event.target as Element).closest<HTMLButtonElement>('[data-invite]')?.dataset.invite;
      if (!choice || !this.invite) return;
      onRespond(this.invite.fromId, choice === 'accept');
      this.close();
    });
  }

  get isOpen(): boolean {
    return !this.root.hidden;
  }

  show(invite: DuelInvite): void {
    this.invite = invite;
    $('.invite-from', this.root).textContent = invite.username;
    this.root.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.close(), DUEL_INVITE_TTL_MS);
  }


  close(): void {
    clearTimeout(this.timer);
    this.root.hidden = true;
    this.invite = null;
  }
}

/** Coop en cours : la pastille du haut de l'écran, avec le partenaire et de quoi quitter la coop. */
export class CoopChip {
  private readonly root = $('#coop-chip');

  constructor(onLeave: () => void) {
    $('.coop-leave', this.root).addEventListener('click', () => onLeave());
  }

  show(state: CoopState): void {
    this.root.hidden = state.partner === null;
    $('.coop-partner', this.root).textContent = state.partner?.username ?? '';
  }
}
